import { Component, Input, Output, OnInit, OnChanges, EventEmitter, ViewEncapsulation } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { FormGroup, Validators, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { ValidationService } from 'lib/ng2-sapmp/src/providers';
import { FormCustomValidator } from './form-custom.validator';
import { FormBuilderService } from './form-builder.service';
import { KEY_CONFIG } from './../../config/key-config';
import { DropdownModel } from './../dropdown/dropdown.model';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';

@Component({
  selector: 'app-form-builder',
  providers: [ValidationService],
  styleUrls: ['./form-builder.component.scss'],
  templateUrl: './form-builder.component.html',
  encapsulation: ViewEncapsulation.None
})

export class FormBuilderComponent implements OnInit, OnChanges {
  @Input() formConfig: any;
  @Input() formName: string;
  @Input() updateformConfig: any;
  appForm: any = {};
  validationMessages: any = {};
  formErrors: any = [];
  @Output() formOutput: EventEmitter<FormGroup>;
  @Output() modelOutput: EventEmitter<any>;
  formCustomValidator = new FormCustomValidator();
  termsConditionPopup = false;
  apnrestriction: string;
  showFormLinkInfo : boolean = false;
  eventEmit: any;
  public formBuilderPopup: ConfirmModalPopupModel;

  constructor(private formBuilder: FormBuilder, private validationService: ValidationService,
    private formBuilderService: FormBuilderService) {
    this.formOutput = new EventEmitter<FormGroup>();
    this.modelOutput = new EventEmitter<any>();
    this.termsConditionPopup = false;
  }

  ngOnInit() {
    this.formBuilderPopup = new ConfirmModalPopupModel();
    if (this.updateformConfig === undefined) {
      this.buildForm(this.formConfig, this.formName);
    }
    this.apnrestriction = sessionStorage.getItem('APNRestriction');
    this.formBuilderService.getForm().subscribe(
      (formGrp: any) => {
        console.log(formGrp);
        if (formGrp === undefined || this.appForm[this.formName] === undefined) {
          return;
        }
        const formGroup = formGrp.formAttribute;
        if (this.appForm[this.formName] !== undefined && formGroup !== undefined) {
          Object.keys(formGroup).forEach((key) => {
            if (key !== 'termsConditions') {
              if (this.appForm[this.formName].controls[key] !== undefined) {
                this.appForm[this.formName].controls[key].setValue(formGroup[key]);
              }
            }
          });
        }
      }
    );
    
  }

  ngOnChanges() {
    this.buildForm(this.formConfig, this.formName);
  }

  private buildForm(formConfig, formName): void {
    const formObj = {};
    const formErrorsObj = {};
    let validationArray = [];
    for (const itrFormConfig of formConfig) {
      validationArray = [];
      if (itrFormConfig.elementType !== 'formGroup' && itrFormConfig.fields === undefined) {
        // itrFormConfig.fields = [itrFormConfig];
        itrFormConfig.fields = [Object.assign({}, itrFormConfig)];
      }

      for (const itrFieldConfig of itrFormConfig.fields) {
        if (itrFieldConfig.validation.required === 'true') {
          if (itrFieldConfig.elementType === 'checkbox') {
            validationArray.push(Validators.requiredTrue);
          } else if (itrFieldConfig.elementType === 'dropdown') {
            validationArray.push(this.formCustomValidator.dropDownValidate);
          } else {
            validationArray.push(Validators.required);
          }
        }
        if (itrFieldConfig.validation.compare && itrFieldConfig.validation.compare.length > 0)
        {
            this.formCustomValidator.setCompare (itrFieldConfig.validation.compare);
            validationArray.push(this.formCustomValidator.validateEntry);
        }
        if (itrFieldConfig.validation.compareWith && itrFieldConfig.validation.compareWith.length > 0)
        {
            this.formCustomValidator.setCompareField (itrFieldConfig.validation.compareWith);
            validationArray.push(this.formCustomValidator.validateReEntry);
        }
        if (itrFieldConfig.validation.pattern) {
          validationArray.push(Validators.pattern(itrFieldConfig.validation.pattern));
        }
        if (itrFieldConfig.validation.minlength) {
          validationArray.push(Validators.minLength(itrFieldConfig.validation.minlength));
        }
        if (itrFieldConfig.validation.maxlength) {
          validationArray.push(Validators.maxLength(itrFieldConfig.validation.maxlength));
        }
        formObj[itrFieldConfig.formControlName] = [itrFieldConfig.initialValue, validationArray];
        formErrorsObj[itrFieldConfig.formControlName] = '';
      }
    }
    this.formErrors = formErrorsObj;
    this.validationMessages = this.createValidationMessageObj();
    this.appForm[formName] = this.formBuilder.group(formObj);
    this.appForm[formName].valueChanges.subscribe(data => this.isFormValid(formName));

    this.validationService.validate(
      this.appForm[formName],
      this.formErrors,
      this.validationMessages);
  }

  private gotoNext(value) {
    this.formOutput.emit(value);
  }

  private createValidationMessageObj() {
    const validationMessagesObj = {};
    for (const itrFormCongig of this.formConfig) {
      for (const itrFieldCongig of itrFormCongig.fields) {
        validationMessagesObj[itrFieldCongig.formControlName] = itrFieldCongig.validation.errorMessages;
      }
    }
    return validationMessagesObj;
  }

  private selected(selectedValue: DropdownModel, listOptions) {
    for (const dropdownValue of listOptions.listValues) {
      if ((selectedValue !== null) && (selectedValue.name === dropdownValue.name) && (selectedValue.value === dropdownValue.value)) {
        listOptions.initialValue = selectedValue.value;
      }
    }
  }
  private isFormValid(formName) {
    this.formOutput.emit(this.appForm[formName]);
  }

  toggleTooltip(event) {
    if (event.type !== 'click') {
      if (event.keyCode !== KEY_CONFIG.enter) {
        return;
      }
    }
    let targetElement = event.target;
    const elems = document.querySelectorAll('.tooltipActive');
    let iselementActive = false;
    if (targetElement.classList.contains('tooltipActive')) {
      iselementActive = true;
    }
    [].forEach.call(elems, function (ele) {
      ele.classList.remove('tooltipActive');
    });
    if (iselementActive) {
      targetElement.classList.remove('tooltipActive');
    } else {
      targetElement.classList.add('tooltipActive');
    }
  }

  onOffSwitchFocus(ele, toggle) {
    if (toggle) {
      ele.parentElement.classList.remove('focused');
    } else {
      ele.parentElement.classList.add('focused');
    }
  }

  showFormLinkInfoModal(event, content) {
    this.formBuilderPopup.modalSubHeader = '';
    this.formBuilderPopup.modalHeader = content.header;
    this.formBuilderPopup.modalMessage = content.message;
    this.formBuilderPopup.showCancelButton = false;
    this.showFormLinkInfo = true;
    this.eventEmit = event.target;
  }

  closeFormLinkInfoModal() {
    this.showFormLinkInfo = false;
  }

}
